/* Product gallery. Loaded only when a product has more than one image.
   A thumbnail tied to a variant is a plain link to that variant, so it needs no script.
   The rest swap the main picture in place; without this file they open the image instead. */
(function () {
  document.querySelectorAll('[data-val-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-val-main]');
    if (!main) return;

    gallery.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-val-thumb]');
      if (!thumb || !gallery.contains(thumb)) return;
      event.preventDefault();

      main.srcset = thumb.dataset.srcset || '';
      main.src = thumb.href;
      var picture = thumb.querySelector('img');
      if (picture) main.alt = picture.alt;

      gallery.querySelectorAll('.val-product__thumb[aria-current]').forEach(function (current) {
        current.removeAttribute('aria-current');
      });
      thumb.setAttribute('aria-current', 'true');
    });
  });
})();
